import { jsx as _jsx } from "react/jsx-runtime";
import { Card } from '@mui/material';
export function DialogueCard(props) {
    return (_jsx(Card, { variant: "elevation", style: {
            ...props.style,
            position: 'absolute',
            left: '50%',
            top: '50%',
            transform: 'translate(-50%, -50%)',
            maxHeight: '95%',
            overflow: 'auto',
        }, children: props.children }));
}
//# sourceMappingURL=DialogueCard.js.map